import { Route, Switch, useHistory } from "react-router-dom";
import { useFeatureFlags } from "../query/hooks/useFeatureFlags";
import { DeletePayableModal } from "./components/DeletePayableModal/DeletePayableModal";
import { InvoiceActions } from "./components/InvoiceActions/InvoiceActions";
import { PaymentsVerificationModal } from "./components/PaymentsVerificationModal/PaymentsVerificationModal";
import { RejectPayableModal } from "./components/RejectPayableModal/RejectPayableModal";
import { AddDefaultPaymentMethodWarningModal } from "./screens/AddDefaultPaymentMethodWarningModal";
import { BulkAdjust1099AmountStep1 } from "./screens/bulkAdjust1099Amount/BulkAdjust1099AmountStep1";
import { BulkAdjust1099AmountStep2 } from "./screens/bulkAdjust1099Amount/BulkAdjust1099AmountStep2";
import { BulkUpdate1099MissingInfoStep1 } from "./screens/bulkAdjust1099MissingInfo/BulkUpdate1099MissingInfoStep1";
import { BulkUpdate1099MissingInfoStep2 } from "./screens/bulkAdjust1099MissingInfo/BulkUpdate1099MissingInfoStep2";
import { BulkUploadCollaboratorsStep1 } from "./screens/bulkUploadCollaborators/BulkUploadCollaboratorsStep1";
import { BulkUploadCollaboratorsStep2 } from "./screens/bulkUploadCollaborators/BulkUploadCollaboratorsStep2";
import { BulkUploadCollaboratorsStep3 } from "./screens/bulkUploadCollaborators/BulkUploadCollaboratorsStep3";
import { InvoicesCollaborators } from "./screens/collaborators/InvoicesCollaborators";
import { InvoicesCollaboratorsIndex } from "./screens/collaborators/InvoicesCollaboratorsIndex";
import { Collaborators1099NECReview } from "./screens/Collaborators1099NECReview";
import { InvoicesClients } from "./screens/InvoicesClients";
import { InvoicesContacts } from "./screens/InvoicesContacts";
import { InvoicesCreate } from "./screens/InvoicesCreate";
import { InvoicesDashboard } from "./screens/InvoicesDashboard";
import { InvoicesDuplicateInvoice } from "./screens/InvoicesDuplicateInvoice";
import { InvoicesDuplicateInvoiceTemplate } from "./screens/InvoicesDuplicateInvoiceTemplate";
import { InvoicesInvoiceConfirmation } from "./screens/InvoicesInvoiceConfirmation";
import { InvoicesInvoiceEdit } from "./screens/InvoicesInvoiceEdit";
import { InvoicesInvoiceTemplateConfirmation } from "./screens/InvoicesInvoiceTemplateConfirmation";
import { InvoicesInvoiceTemplateEdit } from "./screens/InvoicesInvoiceTemplateEdit";
import { InvoicesList } from "./screens/InvoicesList";
import { InvoicesListPaid } from "./screens/InvoicesListPaid";
import { InvoicesSetupComplete } from "./screens/InvoicesSetupComplete";
import { Payables } from "./screens/payables";
import { BulkUploadPayablesInfo } from "./screens/payables/bulkUploadPayables/BulkUploadPayablesInfo";
import { BulkUploadPayablesAndDeductionsReview } from "./screens/payables/bulkUploadPayables/BulkUploadPayablesAndDeductionsReview";
import { BulkUploadPayablesReview } from "./screens/payables/bulkUploadPayables/BulkUploadPayablesReviewV1";
import { BulkUploadPayablesStatus } from "./screens/payables/bulkUploadPayables/BulkUploadPayablesStatus";
import { PaymentsSetup } from "./screens/paymentsSetup";
import { DeductionsIndex } from "./screens/deductions/DeductionsIndex";
import { AddDeduction } from "./screens/deductions/modals/AddDeduction";
import { DeductionInfo } from "./screens/deductions/modals/DeductionsInfo";
import { DeleteDeduction } from "./screens/deductions/modals/DeleteDeduction";

export const Invoices = () => {
  const featureFlagsQuery = useFeatureFlags();
  const history = useHistory();

  return (
    <>
      <PaymentsVerificationModal />
      <AddDefaultPaymentMethodWarningModal />
      <InvoiceActions />
      <DeletePayableModal />
      <RejectPayableModal />
      <AddDeduction />
      <DeductionInfo />
      <DeleteDeduction />

      <Switch>
        <Route
          path="/member/invoices/set-up"
          render={() => (
            <PaymentsSetup
              basePath="/member/invoices/set-up"
              onBack={() => {
                history.push("/member/invoices");
              }}
              onFinish={() => {
                history.push("/member/invoices/complete");
              }}
            />
          )}
        />

        <Route
          path="/member/invoices/complete"
          exact
          component={InvoicesSetupComplete}
        />

        <Route
          path="/member/invoices/create"
          exact
          component={InvoicesCreate}
        />

        <Route
          path="/member/invoices/contacts/clients"
          component={InvoicesClients}
        />

        <Route
          path="/member/invoices/contacts/collaborators/1099/adjust-compensation/download"
          component={BulkAdjust1099AmountStep1}
        />

        <Route
          path="/member/invoices/contacts/collaborators/1099/adjust-compensation/upload"
          component={BulkAdjust1099AmountStep2}
        />

        <Route
          path="/member/invoices/contacts/collaborators/1099/missing-information/download"
          component={BulkUpdate1099MissingInfoStep1}
        />

        <Route
          path="/member/invoices/contacts/collaborators/1099/missing-information/upload"
          component={BulkUpdate1099MissingInfoStep2}
        />

        <Route
          path="/member/invoices/contacts/collaborators/1099"
          component={Collaborators1099NECReview}
        />

        <Route
          path="/member/invoices/contacts/collaborators/bulk-create/info"
          component={BulkUploadCollaboratorsStep1}
        />
        <Route
          path="/member/invoices/contacts/collaborators/bulk-create/upload"
          component={BulkUploadCollaboratorsStep2}
        />
        <Route
          path="/member/invoices/contacts/collaborators/bulk-create/review"
          component={BulkUploadCollaboratorsStep3}
        />
        <Route
          path="/member/invoices/contacts/collaborators/:collaboratorId/deductions"
          component={DeductionsIndex}
        />

        <Route
          path="/member/invoices/contacts/collaborators"
          component={
            featureFlagsQuery.data?.collaboratorGroupsUI
              ? InvoicesCollaboratorsIndex
              : InvoicesCollaborators
          }
        />

        <Route path="/member/invoices/contacts" component={InvoicesContacts} />

        <Route path="/member/invoices/list" component={InvoicesList} />

        <Route path="/member/invoices/paid" component={InvoicesListPaid} />

        <Route
          path="/member/invoices/payables/bulk-upload/info"
          component={BulkUploadPayablesInfo}
        />
        <Route
          path="/member/invoices/payables/bulk-upload/status"
          component={BulkUploadPayablesStatus}
        />
        <Route
          path="/member/invoices/payables/bulk-upload/confirm"
          component={
            featureFlagsQuery.data?.bulkPayableDeductions
              ? BulkUploadPayablesAndDeductionsReview
              : BulkUploadPayablesReview
          }
        />
        <Route path="/member/invoices/payables" component={Payables} />

        <Route
          path="/member/invoices/:invoiceId/edit"
          component={InvoicesInvoiceEdit}
        />
        <Route
          path="/member/invoices/:invoiceId/duplicate"
          exact
          component={InvoicesDuplicateInvoice}
        />
        <Route
          path="/member/invoices/template/:invoiceTemplateId/edit"
          component={InvoicesInvoiceTemplateEdit}
        />
        <Route
          path="/member/invoices/template/:invoiceTemplateId/duplicate"
          exact
          component={InvoicesDuplicateInvoiceTemplate}
        />
        <Route
          path="/member/invoices/:invoiceId/send-success"
          exact
          component={InvoicesInvoiceConfirmation}
        />
        <Route
          path="/member/invoices/template/:invoiceTemplateId/send-success"
          exact
          component={InvoicesInvoiceTemplateConfirmation}
        />

        <Route path="/member/invoices" component={InvoicesDashboard} />
      </Switch>
    </>
  );
};
